import {
	LOG_MODAL_OPEN,
	LOG_INFO
} from './types';

export const open_log_modal = (open) => dispatch => {
	dispatch({
		type: LOG_MODAL_OPEN,
		payload: open
	})
}

export const set_log_info = (log) => dispatch => {
	dispatch({
		type: LOG_INFO,
		payload: log
	})
}
